export default [{
    header: 'Contratos',
    icon: 'FileTextIcon',
    children: [
        {
            title: 'Lista',
            route: 'contracts-list',
            icon: 'ListIcon',
            action: 'read',
		    resource: 'contracts'
        },
        {
            title: 'Nuevo',
            route: 'contracts-create',
            icon: 'PlusSquareIcon',
            action: 'create',
		    resource: 'contracts'
        }
    ]
}];